import { Box, Heading, Stack, Text } from "@chakra-ui/react";

import CustomLink from "components/Chakra/CustomLink";
import Container from "components/Chakra/Container";
import MetaHead from "components/MetaHead";
import IconEmail2 from "components/Chakra/Icons/Email2";
import IconPin2 from "components/Chakra/Icons/Pin2";

const Contact: React.FC = () => (
  <>
    <MetaHead
      title="Kontaktujte nás"
      description="Pokud se nás chcete něco zeptat, navázat obchodní spolupráci, nebo nás jenom pozdravit, budeme rádi za vaši zprávu."
      canonicalUrl="https://www.ulovdomov.cz/kontakt"
    />
    <Container>
      <Heading as="h1" mt="5rem">
        Ozvěte se nám
      </Heading>
      <Text textAlign="center" variant="large_2" pt="30px" pb="48px">
        V případě dotazů se obraťte na naše oddělení klientské podpory.
      </Text>
      <Stack
        spacing={{ base: "32px", xl: "unset" }}
        mt="60px"
        direction={{ base: "column", lg: "row" }}
      >
        <Stack alignItems="center" flex={1}>
          <IconEmail2 id="email2" fillWith="ud-primary" />
          <Text variant="large_2" fontWeight="bold" textAlign="left">
            info@ulovdomov.cz
          </Text>
          <Text variant="large_2" textAlign="center">
            Pište kdykoliv, v pracovních <br />
            dnech odpovíme do 24h.
          </Text>
        </Stack>
        <Stack alignItems="center" flex={1}>
          <IconPin2 fillWith="ud-primary" />
          <Text variant="large_2" fontWeight="bold" textAlign="left">
            UlovDomov.cz s.r.o.
          </Text>
          <Text variant="large_2" textAlign="center">
            Lazaretní 925/9
            <br /> Brno 615 00
          </Text>
        </Stack>
      </Stack>

      <Box my="90px">
        <iframe
          style={{ border: 0 }}
          width="100%"
          height="250"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2606.6521147512863!2d16.636112999999995!3d49.2071587!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47129450a480ad93%3A0xa7eb160f80f254f4!2sUlovDomov.cz!5e0!3m2!1sen!2scz!4v1673382003637!5m2!1sen!2scz"
        />
      </Box>
      <Heading as="h2" my="5rem" fontWeight="light" textAlign="center">
        Firemní údaje a podklady
      </Heading>
      <Stack direction="row" spacing={0} flexWrap="wrap" justify="space-around">
        <Stack direction="column" spacing={2} maxW="300px" mb="30px">
          <Text variant="large_2" textAlign="left" fontWeight="bold">
            UlovDomov.cz s.r.o.
          </Text>
          <Text textAlign="left">
            IČO: 293 00 631 <br />
            DIČ: CZ 293 00 631
          </Text>
          <Text textAlign="left">
            Sídlo firmy:
            <br />
            Lazaretní 925/9
            <br />
            Brno 615 00
          </Text>
          <Text textAlign="left">
            Základní kapitál 1,2 milionu Kč
            <br />
            zapsaná 17. prosince 2011 C 72444
            <br />
            vedená u Krajského soudu v Brně
          </Text>
        </Stack>
        <Stack direction="column" maxW="300px" spacing={2}>
          <Text variant="large_2" textAlign="left" fontWeight="bold">
            Pro média
          </Text>
          <Stack spacing={0} mb={{ md: "114px" }}>
            <CustomLink href="/img/common/logo.png" isExternal>
              <Text color="ud-primary" textAlign="left" whiteSpace="nowrap">
                Logo UlovDomov.cz
              </Text>
            </CustomLink>
          </Stack>
        </Stack>
      </Stack>
    </Container>
  </>
);

export default Contact;
